<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">{{ 'Home' | translate }}</a> > {{ 'Performance do Usuário' | translate}}
    </div>
</div>

<main class="container">
    <div class="flex space-between align-center">
        <h1>{{ 'Performance do Usuário' | translate}}</h1>
        <div class="export-button">
            <button (click)="exportToExcel()" class="red_button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                {{ 'Exportar para Excel' | translate }}
            </button>
        </div>
    </div>
    
    <div class="filtros">
        <div class="filtro">
            <label for="cboUsuario">{{ 'Usuário' | translate}}</label>
            <select id="cboUsuario" [(ngModel)]="filtro.usuario" (change)="atualizaFiltro()">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let usuario of listaUsuarios" [value]="usuario.email">{{ usuario.email }}</option>
            </select>
        </div>

        <div class="filtro">
            <label for="cboPais">{{ 'País' | translate}}</label>
            <select id="cboPais" [(ngModel)]="filtro.pais" (change)="atualizaFiltro()">
                <option value="">{{ 'Todos' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.id">{{ pais.name }}</option>
            </select>
        </div>

        <div class="filtro">
            <label for="dataInicial">{{ 'Data Inicial' | translate}}</label>
            <input type="date"
                   id="dataInicial"
                   [(ngModel)]="filtro.dataInicial"
                   (change)="atualizaFiltro()" />
        </div>

        <div class="filtro">
            <label for="dataFinal">{{ 'Data Final' | translate}}</label>
            <input type="date"
                   id="dataFinal"
                   [(ngModel)]="filtro.dataFinal"
                   (change)="atualizaFiltro()" />
        </div>

        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="clearFiltros()" class="clear-button">
                {{ 'Limpar Filtros' | translate }}
            </button>
        </div>
    </div>

    <div *ngIf="filtroError" class="filtro-error">
        {{ filtroError }}
    </div>

    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>{{ 'País' | translate }}</th>
                    <th>{{ 'E-mail do Usuário' | translate }}</th>
                    <th>{{ 'Data' | translate }}</th>
                    <th>{{ 'Hora Início' | translate }}</th>
                    <th>{{ 'Hora Fim' | translate }}</th>
                    <th>{{ 'Total Tempo' | translate }}</th>
                    <th>{{ 'Tempo Médio' | translate }}</th>
                    <th>{{ 'Média de Transição' | translate }}</th>
                    <th>{{ 'Total Receitas' | translate }}</th>
                    <th>{{ 'Total Produtos' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of filteredData | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalItems }">
                    <tr>
                        <td>{{ item.nomePais }}</td>
                        <td>{{ item.emailRevisor }}</td>
                        <td>{{ item.dataRevisao }}</td>
                        <td>{{ item.initialOperation }}</td>
                        <td>{{ item.finalOperation }}</td>
                        <td>{{ item.totalTempoPermanencia }}</td>
                        <td>{{ item.mediaTempoPermanencia }}</td>
                        <td>{{ item.mediaTempoTransicaoPorReceita }}</td>    
                        <td>{{ item.totalReceitas }}</td>
                        <td>{{ item.totalPrescricoes }}</td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredData.length === 0">
                    <td colspan="11" class="text-center">{{ 'Nenhum dado encontrado' | translate }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="text-center pagination" *ngIf="arredondar(totalItems / pageSize) >= 2">
        <pagination-controls id="userPerformancePagination" (pageChange)="onPageChange($event)" previousLabel="" nextLabel=""></pagination-controls>
        <div class="pagination-info">
            <span>{{ 'Página' | translate}}</span> {{ currentPage }} <span>{{ 'de' | translate}}</span> {{ arredondar(totalItems / pageSize) }} - {{ 'total de itens' | translate}}: {{ totalItems }}
        </div>
    </div>
</main>
